<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<span>创建时间：</span>
				<el-date-picker
					v-model="dateValue"
					:clearable="false"
					size="small"
					type="datetimerange"
					align="right"
					style="width:405px"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-name-box">
				<span>优惠券：</span>
				<el-input v-model="name" placeholder="优惠券名称/优惠券编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>优惠券类型：</span>
				<el-select v-model="type" multiple collapse-tags placeholder="请选择优惠券类型" class="order-type-select" size="small">
					<!-- <el-option label="全部" value="全部"></el-option> -->
					<el-option label="满减券" value="1"></el-option>
					<el-option label="商品券" value="6"></el-option>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>客户名称：</span>
				<el-input v-model="customerName" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>获取方式：</span>
				<el-select v-model="forceflag" multiple collapse-tags class="order-type-select" size='small'>
					<!-- <el-option value="0" label="全部"></el-option> -->
					<el-option value="0" label="强制发放"></el-option>
					<!-- <el-option value="1" label="买赠活动"></el-option> -->
				</el-select>
			</div>
			<div class="order-type-box">
				<span>生效状态：</span>
				<el-select v-model="discountstate" class="order-type-select" collapse-tags multiple size='small'>
					<!-- <el-option value="0" label="全部"></el-option> -->
					<el-option value="未生效" label="未生效"></el-option>
					<el-option value="进行中" label="进行中"></el-option>
					<el-option value="已结束" label="已结束"></el-option>
				</el-select>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			discountstate: [],
			shopList: [],
			refundnumber: '',
			name: '',
			dateValue: [],
			dateValue1: [],
			dateValue2: [],
			customerName: '',
			matchCode: '',
			customerCode: '',
			pcode: '',
			bigcategoryview: null,
			bigcategoryid: [],
			smallcategoryid: [],
			bc: [],
			sc: [],
			type: [],
			forceflag: [],
			customList: [],
			spec: '',
			specCode: '',
			collapse: true,
			memo: ''
		}
	},
	created () {
		this.checkSmallCategory()
		// this.getBigCategory()
		// this.getCustomer()
		this.initFilters()
		// this.getShopList()
	},
	methods: {
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		bcChange (value) {
			if (this.bigcategoryview === 1 && value.length > 0) {
				if (value.length > this.bigcategoryidLength) {
					this.bigcategoryidLength = value.length
				} else {
					this.smallcategoryid = []
				}
				this.getSmalCategory()
			}	else {
				this.sc = []
				this.smallcategoryid = []
				this.getSmalCategory()
			}
		},
		removeBigCategoryid () {
			this.smallcategoryid = []
		},
		getSmalCategory () {
			let params = {
				pids: this.bigcategoryid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
				let Params = decodeURI(this.$route.query.queryParams)
				let queryParams = this.$fxUtils.JSONparse(Params)
				if (queryParams.startDate && queryParams.endDate) {
					this.dateValue = [queryParams.startDate.data, queryParams.endDate.data]
				} else {
					this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				}
				if (queryParams.name) {
					this.name = queryParams.name.data
				}
				if (queryParams.type) {
					this.type = queryParams.type.data.split(',')
				}
				if (queryParams.customername) {
					this.customerName = queryParams.customername.data
				}
				if (queryParams.forceflag) {
					this.forceflag = queryParams.forceflag.data.split(',')
				}
				if (queryParams.discountstate) {
					this.discountstate = queryParams.discountstate.data.split(',')
				}
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		clearSearch () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			this.customerName = ''
			this.name = ''
			this.type = []
			this.forceflag = []
			this.discountstate = []
		},
		getFiltersDate () {
			if (this.dateValue.length > 0) {
				return [
					{ name: 'startDate', field: 'startDate', value: `${this.dateValue[0]}:00`, 'op': 'ge', type: 'filtersParams' },
					{ name: 'endDate', field: 'endDate', value: `${this.dateValue[1]}:59`, 'op': 'le', type: 'filtersParams' }
				]
			}
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (+this.dateValue === 0 ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = []
			} else {
				filtersParams = [
					{ field: 'startDate', data: `${this.dateValue[0]}:00`, 'op': 'ge' },
					{ field: 'endDate', data: `${this.dateValue[1]}:59`, 'op': 'le' }
				]
			}
			if (this.discountstate.length > 0) {
				let data = this.discountstate.join(',')
				let shopObj = { 'field': 'discountstate', 'data': data, 'op': 'in' }
				filtersParams.push(shopObj)
			}
			if (this.forceflag.length !== 0) {
				let forceflag = { 'field': 'forceflag', 'data': this.forceflag.join(','), 'op': 'in' }
				filtersParams.push(forceflag)
			}
			if (this.customerName) {
				let customerNameObj = { 'field': 'customername', 'data': this.customerName, 'op': 'cn' }
				filtersParams.push(customerNameObj)
			}
			if (this.name) {
				let nameObj = { 'field': 'name', 'data': this.name, 'op': 'cn' }
				filtersParams.push(nameObj)
			}
			if (this.type.length !== 0) {
				let type = { 'field': 'type', 'data': this.type.join(','), 'op': 'in' }
				filtersParams.push(type)
			}

			return {
				filtersParams,
				cParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		// margin-bottom: 10px
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 105px;
				text-align: right
			}
		}
		.data-picker-box {
			// margin-right:10px
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
